/**
 * @file index.js
 * @author Andres Solarte
 * @description Initialize Ambulatory Monitoring View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './AmbulatoryMonitoringIBView';

export const mapStateToPropsAmbulatoryMonitoringIBList = mapStateToProps;
export const mapDispatchToPropsAmbulatoryMonitoringIBList = mapDispatchToProps;

export default connect(
  mapStateToPropsAmbulatoryMonitoringIBList,
  mapDispatchToPropsAmbulatoryMonitoringIBList
)(View);
